<template>
  <bita-modal
    id="edit-form"
    :title="title"
    :modal-lg="true"
    :is-loading="isLoading"
    @close="onModalClose()"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="name"
              label="نام"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.name"
            />
            <bita-input
              type="text"
              name="slug"
              label="نام انگلیسی"
              rules=""
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.slug"
            />
            <bita-colorpicker
              v-if="form.type == 2"
              ref="colorPicker"
              name="color"
              label="رنگ"
              rules=""
              validation-container-class="col-lg-2"
              input-class="form-control"
              v-model="color"
            />
            <bita-uploader
              name="uploader"
              label="تصویر"
              rules="size:50"
              ref="uploader"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.image"
              :icon-url="form.image_full_url"
              :deletable="true"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!form.id"
        type="primary"
        title="ذخیره"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="save"
      />
      <bita-bootbutton
        v-else
        title="بروزرسانی"
        type="primary"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="update"
      />
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    title: String,
    isLoading: Boolean,
    categories: {},
  },
  data() {
    return {
      colWidth: "col-lg-4",
      form: {},
      color: "#ffffff",
    };
  },
  mounted() {},
  computed: {
    formRef() {
      return this.$refs.form;
    },
  },
  methods: {
    initialData(_id, _name, _slug, _color, _type, _image, _image_full_url) {
      this.form = {
        id: _id,
        name: _name,
        slug: _slug,
        type: _type,
        image: _image,
        image_full_url: _image_full_url
      };
      console.log("aaa", this.form);
      this.$nextTick(() => {
        this.color = _color ? _color : "#ffffff";
      });
    },
    open(feature) {
      this.form.type = feature.type;
    },
    save() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          let d = this.form;
          if (this.form.type == 2) d = { ...this.form, color: this.color };
          this.$emit("on-create", d);
        }
      });
    },
    update() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          let d = this.form;
          if (this.form.type == 2) d = { ...this.form, color: this.color };
          this.$emit("on-update", d);
        }
      });
    },
    reset() {
      this.form = {};
      this.color = "#ffffff";
      this.formRef.reset();
      this.$refs.uploader.reset();
    },
    onModalClose() {
      this.reset();
      this.$emit("close");
    },
    setErrors(_errors) {
      this.$refs.form.setErrors(_errors);
    },
  },
};
</script>
